import * as React from "react"
import { connect } from "react-redux"

import {
    Theme,
    css,
} from "@bdfx/mergado-ui-kit"

import { IOptionProps, Option as SelectOption } from "react-select-item";

import { FiltersFormType, emptyFiltersState } from "../types/filtertypes";
import { ENTER_KEY } from "app/helpers/keymap";
import BasicFilters from "./basic-filters";
import { DiagnosticsType } from "../types";
import { ID, ReduxList } from "app/types/app-types";
import { FIEQueryType } from "./fie-queries";
import intersection from "lodash/intersection";
import { selectFormValues } from "app/reducers/form";
import { iconDisabledColor } from "template-edit/components/tools-panel";
import { setIsLoadingProducts, setProductsToStore } from "products/reducer";

export type MinMaxType = { from: number, to: number, label: string, value: string }
export type SizeType = { width: number, height: number }

export const isMultiSelectCloseOnChange = true

export type FilterIsOpenType = 'product' | 'image' | 'background' | 'size_format' | 'product_elements' | 'watermarks' | 'validations' | 'images_quality' | 'visual_similarity' | 'person'
export const FilterIsOpenTypes: FilterIsOpenType[] = ['product', 'product_elements', 'image', 'background', 'size_format', 'watermarks', 'validations', 'person', 'images_quality', 'visual_similarity']

export type FType = 'product' | 'image_validations' | 'image' | 'elements' | 'watermark' | 'quality' | 'person' | 'visual_similarity'
export const FTypes: FType[] = ['product', 'image_validations', 'image', 'elements', 'watermark', 'quality', 'person', 'visual_similarity']

export function getNonEmptyFiltersForType(filtersForm: FiltersFormType, filterType: FType) {

    const nonEmptyFilters = filtersForm[filterType] ? Object.keys(filtersForm[filterType])
        .filter(key =>
            filtersForm[filterType][key] !== emptyFiltersState[filterType][key] &&
            filtersForm[filterType][key] !== null &&
            filtersForm[filterType][key] !== '' &&
            !(Array.isArray(filtersForm[filterType][key]) && filtersForm[filterType][key].length === 0 ) &&
            !(['probability', 'score', 'confidence'].includes(key) &&
                (
                    (!filtersForm[filterType][key].from && !filtersForm[filterType][key].to) ||
                    (parseFloat(`${filtersForm[filterType][key].from}`) === parseFloat(`${emptyFiltersState[filterType][key].from}`) &&
                        parseFloat(`${filtersForm[filterType][key].to}`) === parseFloat(`${emptyFiltersState[filterType][key].to}`))
                )
            ) &&
            !(key === 'bg_color_distance' && !filtersForm[filterType]['bg_color'])
        ) : []

    return nonEmptyFilters
}

interface Props {
    filtersForm: FiltersFormType
    setProductsToStore: typeof setProductsToStore,
    setIsLoadingProducts: typeof setIsLoadingProducts,
    updateProducts: Function
    updateProductsBounced: Function
    updateProductsBouncedFast: Function
    getEmptyFiltersForm: Function
    setIsDirty: Function
    isDirty: boolean
    products: ReduxList<DiagnosticsType>
    fieQueries: ReduxList<FIEQueryType[]>
    activeFIEQueryId: ID
    userId: number
    verticalMode: boolean
}

interface State {
    openedFilters: FilterIsOpenType[]
    nonEmptyFilters: FilterIsOpenType[]
}

class Filters extends React.Component<Props, State>
{
    constructor(props: Props) {
        super(props)

        this.state = {
            openedFilters: [...FilterIsOpenTypes],
            nonEmptyFilters: [],
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && prevProps.filtersForm) {
            if (JSON.stringify(prevProps.filtersForm) !== JSON.stringify(this.props.filtersForm)) {
                //filters changed
                this.checkNonEmptyFilters()
                //this.props.updateProducts()
            } else if (prevProps.verticalMode !== this.props.verticalMode) {
                //vertical mode changed
                this.setState({ openedFilters: this.props.verticalMode ? this.state.nonEmptyFilters : [...FilterIsOpenTypes] })
            }
        }
    }

    checkNonEmptyFilters = () => {
        const { filtersForm } = this.props

        const backgroundItems = ['bg_color', 'is_light_bg', 'is_solid_bg', 'is_transparent', 'bg_color_distance']
        const sizeFormatItems = ['width', 'height', 'content_length']
        const productsItems = ['showGroup']

        let nonEmptyFilters: FilterIsOpenType[] = []
        if (filtersForm) {
            FTypes.forEach((filterType: FType) => {
                const items = getNonEmptyFiltersForType(filtersForm, filterType)
                if (items.length > 0) {
                    //subdivision of image and product filters:
                    switch (filterType) {
                        case "image":
                            if (intersection([...backgroundItems, ...sizeFormatItems, ...productsItems], items).length < 1) {
                                nonEmptyFilters.push('image')
                            } else {
                                if (intersection(backgroundItems, items).length > 0) {
                                    nonEmptyFilters.push('background')
                                }
                                if (intersection(sizeFormatItems, items).length > 0) {
                                    nonEmptyFilters.push('size_format')
                                }
                                if (intersection(productsItems, items).length > 0) {
                                    nonEmptyFilters.push('product')
                                }
                            }
                            break
                        case "product":
                            if (intersection(['check_elements_availability'], items).length > 0) {
                                nonEmptyFilters.push('product_elements')
                            } else {
                                nonEmptyFilters.push('product')
                            }
                            break
                        case "elements":
                            nonEmptyFilters.push('product_elements')
                            break
                        case "image_validations":
                            nonEmptyFilters.push('validations')
                            break
                        case "quality":
                            nonEmptyFilters.push('images_quality')
                            break
                        case "watermark":
                            nonEmptyFilters.push('watermarks')
                            break
                        default:
                            nonEmptyFilters.push(filterType)
                            break
                    }
                }
            })
            this.setState({ nonEmptyFilters: nonEmptyFilters })
        }
    }

    handleKeyDown = (event) => {
        if (event.keyCode === ENTER_KEY && event.target.localName !== "textarea" && event.target.getAttribute('data-active') !== "1") {
            event.preventDefault()
            const el = document.getElementById('submit-button')
            if (el) {
                el.click()
            }
        }
    }

    toggleFilterIsOpen = (type: FilterIsOpenType, onlyOne: boolean = false) => {
        const { openedFilters } = this.state

        let updatedOpenedFilters = []

        if (onlyOne) {
            updatedOpenedFilters = [type]
        } else {
            if (openedFilters.includes(type)) {
                updatedOpenedFilters = openedFilters.filter((t: FilterIsOpenType) => (t !== type))
            } else {
                updatedOpenedFilters = [...openedFilters, type]
            }
        }

        this.setState({ openedFilters: updatedOpenedFilters })
    }

    render() {
        const { userId, verticalMode } = this.props
        const { openedFilters, nonEmptyFilters } = this.state


        return (
            <StyledFiltersWrapper>
                {/*{!verticalMode &&
            <InputGroup
                orientation="horizontal"
                className={'select-filters'}
                value={openedFilters}
                items={FilterIsOpenTypes.map((type: FilterIsOpenType) => {
                    return {value: type, label: trans(type)}
                })}
                onChange={(selectedTypes : FilterIsOpenType[]) => {
                    this.setState({openedFilters: selectedTypes})
                }}
            />
            }*/}

                <StyledFilters>
                    <BasicFilters
                        setIsDirty={this.props.setIsDirty}
                        userId={userId}
                        verticalMode={verticalMode}
                        openedFilters={openedFilters}
                        nonEmptyFilters={nonEmptyFilters}
                        toggleFilterIsOpen={this.toggleFilterIsOpen}
                    />
                </StyledFilters>
            </StyledFiltersWrapper>
        )
    }
}

export class CustomStatusOption extends SelectOption<IOptionProps, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        const t: any = this
        const { option } = t.props

        return (
            <StyledCustomOption
                {...t.getOptionProps(option)}
                style={{
                    color: option.active ? '#000' : '#bbb'
                }}
            >
                {option.title}
            </StyledCustomOption>
        );
    }
}

export class CustomTemplateOption extends SelectOption<IOptionProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const t: any = this
        const { option } = t.props

        return (
            <StyledCustomOption
                {...t.getOptionProps(option)}
                style={{ color: option.active ? '#000' : '#bbb' }}
            >
                {option.title}
            </StyledCustomOption>
        );
    }
}

export class CustomGroupsOption extends SelectOption<IOptionProps, {}> {
    constructor(props) {
        super(props);
    }

    public render() {
        const t: any = this
        const { option } = t.props

        return (
            <StyledCustomOption {...t.getOptionProps(option)}>
                {option.icon}{option.title}
            </StyledCustomOption>
        );
    }
}

const StyledCustomOption = css('div')({
    minHeight: '32px',
    color: '#000 !important',
    '.muk-icon': {
        paddingRight: '5px',
    },
    '.react-select-item-option-selected': {
        color: '#fff !important',
    },
})

const StyledFiltersWrapper = css('div')({
    paddingTop: 0,
    ' .advanced-search-button': {
        padding: '4px 5px',
        marginBottom: '20px',
        marginTop: 0,
    },
    ' .button-off': {
        borderRadius: 0,
        borderBottomRightRadius: Theme.radius,
        " .muk-icon--chevron-up-light path": { "fill": "none !important" }
    },
    ' .button-on': {
        " .muk-icon--chevron-down-light path": { "fill": "none !important" }
    },
    ' .filter-buttons': {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        display: 'grid',
        marginBottom: '20px',
        textAlign: 'center',
        alignSelf: 'center',
    }
})

const StyledFilters = css('div')({
    ' .buttons': {
        paddingTop: '0px',
    },
    '@media screen and (max-width: 600px)': {
        gridTemplateColumns: 'auto auto',
        gridGap: '5px',
        ' .select-filters .muk-grid': {
            gridGap: 0,
            gridAutoFlow: 'row !important',
            gridTemplateColumns: 'repeat(3, auto)',
            ' span.muk-button': {
                height: '100%',
            },
            marginBottom: '20px',
        }
    },
    ' .filter-button': {
        cursor: 'pointer',
        display: 'grid',
        alignSelf: 'center',
    },
    ' label.muk-form-label span.muk-span.muk-icon img.m-image': {
        marginRight: '7px',
    }
})

export const StyledSliderDiv = css('div')({
    position: 'relative',
    padding: '0 25px',
    ' .MuiSlider-colorSecondary': {
        color: iconDisabledColor,
        ' .MuiSlider-track': {
            backgroundColor: iconDisabledColor,
            borderColor: iconDisabledColor,
        }
    },
})

function mapStateToProps(state) {
    return {
        filtersForm: selectFormValues(state, 'filtersForm'),
        products: state.products,
        fieQueries: state.fieQueries,
        activeFIEQueryId: state.activeFIEQueryId,
    }
}

export default connect(mapStateToProps, {
    setProductsToStore,
    setIsLoadingProducts,
})(Filters)
